<template>
    <div>
        <div class="common-table">
            <el-table v-loading="loading" height="100%" :data="horseRaceLampLog.beanList" row-key="opTime">
                <el-table-column type="index" label="编号" align="center"/>
                <el-table-column label="注入奖池数量" min-width="120" align="center" prop="kdou"/>
                <el-table-column label="注入前奖池金豆" min-width="120" align="center" prop="beforeGameAccountKdou"/>
                <el-table-column label="注入后奖池金豆" min-width="120" align="center" prop="afterGameAccountKdou"/>
                <el-table-column label="注入前账户金豆余额" min-width="150" align="center" prop="beforeMarketAccountKdou"/>
                <el-table-column label="注入后账户金豆余额" min-width="150" align="center" prop="afterMarketAccountKdou"/>
                <el-table-column label="注入时间" width="150" align="center" prop="Date"/>
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="horseRaceLampLog.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                currentPage:1
            }
        },
        computed: {
            ...mapState('market', ['horseRaceLampLog'])
        },
        methods: {
            ...mapActions('market', ['getHorseRaceLampLog']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getHorseRaceLampLog(page).then(() => {
                    this.loading = false;
                })
            }
        }
    }
</script>
